export default theme => ({
  root: {},
  icon: {
    width: 20, height: 20,
  },
});
